export default __webpack_public_path__ + "static/media/080_finish_bad.first.7282876c.webp";